import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiBaseUrls } from '../config/config';
import { AuthService } from '../Auth/auth.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private headersData:any = {};

  private apiUrl:any = {
    listing: apiBaseUrls + 'faqs/list',
    create: apiBaseUrls + 'faqs/create',
    show: apiBaseUrls + 'faqs/show/',
    update: apiBaseUrls + 'faqs/update/',
    delete: apiBaseUrls + 'faqs/delete/',
    categories: apiBaseUrls + 'faqs_category/categories'
  };
  
  constructor(private authService: AuthService, private http: HttpClient) {
  }

  apiCall(apiType:any, formData:any = null) {
    let Url = this.apiUrl[apiType];

    this.headersData = this.authService.setTokenHeader();
    
    switch(apiType) {
      case 'create':
        return this.http.post(Url, formData, this.headersData);
      break;

      case 'show':
        Url = Url + formData;
        return this.http.get(Url, this.headersData);
      break;

      case 'update':
        Url = Url + formData.id;
        return this.http.put(Url, formData, this.headersData);
      break;

      case 'delete':
        Url = Url + formData;
        return this.http.delete(Url, this.headersData);
      break;

      case 'listing':
      default:
        return this.http.post(Url, formData, this.headersData);
      break;

      case 'categories':
        Url = Url;
        return this.http.get(Url, this.headersData);
      break;
    }
  }
}
